class Scroll {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function () {
      if (window.matchMedia('(max-width: 768px)').matches) {
        
      } else {

        var timeoutId ;
        window.addEventListener( "scroll", function () {
        // setTimeout()がセットされていたら無視
        if ( timeoutId ) return ;
        timeoutId = setTimeout( function () {
          timeoutId = 0 ;
          $(window).scroll(function() {
            if(window.scrollY + $(".js-header")[0].clientHeight > $(".js-footer")[0].offsetTop) {
                $(".js-header").addClass("is-active");
            } else {
                $(".js-header").removeClass("is-active");
            }
        })
        }, 500 ) ;
        } ) ;
      }
    })

  }
}
